var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgSpinner18 = function SvgSpinner18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "spinner-circle",
    cx: 9,
    cy: 9,
    r: 8,
    stroke: "#333",
    strokeOpacity: 0.1,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "spinner-spline",
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M17 9a8 8 0 00-8-8"
  }))));
};
export default SvgSpinner18;